import React from 'react';
import './QuoteBlock.css';

const QuoteBlock = () => {
  return (
    <section className="quote-block">
      <blockquote>
        "The future belongs to those who believe in the beauty of their dreams." – Eleanor Roosevelt
      </blockquote>
    </section>
  );
};

export default QuoteBlock;